module.exports = __webpack_public_path__ + "static/img/layout-1.a4629b63.jpg";